import { StaticImage } from "gatsby-plugin-image";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LanguageContext, text } from "../../container/language";

export const DigitalPlatforms = () => {
  const { userLanguage } = useContext(LanguageContext);
  const { t } = useTranslation();

  const platforms = [
    {
      name: "eLearning",
      image: "../../../static/images/platforms/e-learning.jpg",
      description:
        "Fusce dapibus tellus cursus porta tortor condimentum euismod massa justo vehicula sit amet et risus cras.",
    },
    {
      name: "eCommentary",
      image: "../../../static/images/platforms/e-commentary.jpg",
      description:
        "Fusce dapibus tellus cursus porta tortor condimentum euismod massa justo vehicula sit amet et risus cras.",
    },
    {
      name: "eLibrary",
      image: "../../../static/images/platforms/e-library.jpg",
      description:
        "Fusce dapibus tellus cursus porta tortor condimentum euismod massa justo vehicula sit amet et risus cras.",
    },
  ];

  return (
    <>
      <div className="row text-center">
        <div className="col-lg-9 col-xl-8 col-xxl-7 mx-auto">
          <h2 className="display-4 mb-3 text-center">
            {t("pages.home.digitalPlatforms.title")}
          </h2>
          <p className="lead mb-10 text-center px-md-16 px-lg-21 px-xl-0">
            {t("pages.home.digitalPlatforms.description")}
          </p>
        </div>
      </div>
      <div className="row  text-center">
        <div className="col-md-3">
          <a href="http://moodle.magjistratura.edu.al/" target="_blank">
            <div className="icon btn btn-block btn-lg btn-white disabled mb-5">
              <StaticImage
                src="../../../static/images/platforms/e-learning.jpg"
                alt="E Learning"
                class="buttons-of-master"
              />
            </div>
          </a>
          <h4>
            <a
              href="http://moodle.magjistratura.edu.al/"
              target="_blank"
              className="eee-3"
            >
              eLearning
            </a>
          </h4>
        </div>
        <div className="col-md-3">
          <a
            href="http://komentarielektronik.magjistratura.edu.al/"
            target="_blank"
          >
            <div className="icon btn btn-block btn-lg btn-white disabled mb-5">
              <StaticImage
                src="../../../static/images/platforms/slide-bg1.jpg"
                alt="E-Commentary"
                class="buttons-of-master"
              />
            </div>
          </a>
          <h4>
            <a
              href="http://komentarielektronik.magjistratura.edu.al/"
              target="_blank"
              className="eee-3"
            >
              eCommentary
            </a>
          </h4>
        </div>
        <div className="col-md-3">
          <a href="http://www.jurisdocsmagjistratura.edu.al/" target="_blank">
            <div className="icon btn btn-block btn-lg btn-white disabled mb-5">
              <StaticImage
                src="../../../static/images/platforms/slide-bg2.jpg"
                alt="E Library"
                class="buttons-of-master"
              />
            </div>
          </a>
          <h4>
            <a
              href="http://www.jurisdocsmagjistratura.edu.al/"
              target="_blank"
              className="eee-3"
            >
              Baza e të dhënave
            </a>
          </h4>
        </div>
        <div className="col-md-3">
          <a
            href="https://magjistratura.edu.al/sq/programe-and-formime/lojera-interaktive"
            target="_blank"
          >
            <div className="icon btn btn-block btn-lg btn-white disabled mb-5">
              <StaticImage
                src="../../../static/images/platforms/games.jpg"
                alt="Lojera Interaktive"
                class="buttons-of-master"
              />
            </div>
          </a>
          <h4>
            <a
              href="https://magjistratura.edu.al/sq/programe-and-formime/lojera-interaktive"
              target="_blank"
              className="eee-3"
            >
              Lojëra Interaktive
            </a>
          </h4>
        </div>
      </div>
    </>
  );
};

export default DigitalPlatforms;
